import * as React from "react";
const SvgIcCheck = props => <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="m17.5 5.833-10 10-4.583-4.583 1.175-1.175 3.408 3.4 8.825-8.817L17.5 5.833Z" /></svg>;
export default SvgIcCheck;